module.exports = __webpack_public_path__ + "img/faq-illustrations.056d9308.svg";